import { render, staticRenderFns } from "./WatchLists.vue?vue&type=template&id=99dac8c4&"
import script from "./WatchLists.vue?vue&type=script&lang=js&"
export * from "./WatchLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports